import IconHome from '@/components/icons/IconHome'
import IconBolt from '@/components/icons/IconBolt'
import IconLaunch from '@/components/icons/IconLaunch'
import IconCheck from '@/components/icons/IconCheck'
import IconExternalWindow from '@/components/icons/IconExternalWindow'
import IconImportant from '@/components/icons/IconImportant'
import IconBuoy from '@/components/icons/IconBuoy'
import IconSwatch from '@/components/icons/IconSwatch'
import IconRefresh from '@/components/icons/IconRefresh'
import IconSecurityCheck from '@/components/icons/IconSecurityCheck'
import IconCloseCircle from '@/components/icons/IconCloseCircle'
import IconMenu from '@/components/icons/IconMenu'
import IconClose from '@/components/icons/IconClose'
import IconCode from '@/components/icons/IconCode'
import IconDoorExit from '@/components/icons/IconDoorExit'

import IconLock from '@/components/icons/IconLock'
import IconStar from '@/components/icons/IconStar'
import IconUser from '@/components/icons/IconUser'
import IconChart from '@/components/icons/IconChart'
import IconEdit from '@/components/icons/IconEdit'
import IconTrophy from '@/components/icons/IconTrophy'
import IconClickTarget from '@/components/icons/IconClickTarget'
import IconBug from '@/components/icons/IconBug'
import IconLight from '@/components/icons/IconLight'

import IconMoodHappy from '@/components/icons/IconMoodHappy'

export default {
  install (Vue) {
    Vue.component('IconHome', IconHome)
    Vue.component('IconBolt', IconBolt)
    Vue.component('IconLaunch', IconLaunch)
    Vue.component('IconCheck', IconCheck)
    Vue.component('IconExternalWindow', IconExternalWindow)
    Vue.component('IconImportant', IconImportant)
    Vue.component('IconBuoy', IconBuoy)
    Vue.component('IconSwatch', IconSwatch)
    Vue.component('IconRefresh', IconRefresh)
    Vue.component('IconSecurityCheck', IconSecurityCheck)
    Vue.component('IconCloseCircle', IconCloseCircle)
    Vue.component('IconMenu', IconMenu)
    Vue.component('IconClose', IconClose)
    Vue.component('IconCode', IconCode)
    Vue.component('IconDoorExit', IconDoorExit)

    Vue.component('IconLock', IconLock)
    Vue.component('IconStar', IconStar)
    Vue.component('IconUser', IconUser)
    Vue.component('IconChart', IconChart)
    Vue.component('IconClickTarget', IconClickTarget)
    Vue.component('IconBug', IconBug)
    Vue.component('IconLight', IconLight)

    Vue.component('IconMoodHappy', IconMoodHappy)
    Vue.component('IconEdit', IconEdit)
    Vue.component('IconTrophy', IconTrophy)
  }
}
